import { render, staticRenderFns } from "./CompleteSalesOrders.vue?vue&type=template&id=485ca3f2"
import script from "./CompleteSalesOrders.vue?vue&type=script&lang=js"
export * from "./CompleteSalesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485ca3f2')) {
      api.createRecord('485ca3f2', component.options)
    } else {
      api.reload('485ca3f2', component.options)
    }
    module.hot.accept("./CompleteSalesOrders.vue?vue&type=template&id=485ca3f2", function () {
      api.rerender('485ca3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CompleteSalesOrders.vue"
export default component.exports